import { useKnowledgebaseEntries } from "@/lib/api";
import { Grid, Skeleton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import KnowledgeEntry from "./KnowledgeEntry";

const style = {
  "& .knowledge": {
    "&--entry": {
      "&:first-of-type": {
        borderTopLeftRadius: ".5rem",
        borderTopRightRadius: ".5rem",
      },
      "&:last-of-type": {
        marginBottom: "2rem",
        borderBottomLeftRadius: ".5rem",
        borderBottomRightRadius: ".5rem",
      },
      "&:not(:last-of-type)": {
        marginBottom: "-1px",
      },
    },
  },
};

const KnowledgeList = ({categories}) => {

  return (
    <Box>
      {categories?.map((category) => {
        return (
          <Box key={category.id}>
            <Typography variant="h4" component="p" color="common.black">
              {category.title}
            </Typography>
            <Grid container>
              <Grid item xs={12} sx={style}>
                {category.knowledge_base_entries?.map((entry) => {
                  return <KnowledgeEntry key={entry.id} entry={entry} />;
                })}
              </Grid>
            </Grid>
          </Box>
        );
      })}
    </Box>
  );
};

export default KnowledgeList;
